import { useSelector } from 'react-redux'

import { isNotificationCustomizationRestrictedSelector } from 'selectors/current_organization'

export const useIsNotificationCustomizationRestricted = () => useSelector(isNotificationCustomizationRestrictedSelector)
